import { render } from "./ProTradingCenters.vue?vue&type=template&id=19759883"
import script from "./ProTradingCenters.vue?vue&type=script&lang=js"
export * from "./ProTradingCenters.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__